// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refDataFormatService = {
    getByAccount,
    getById,
    add,
    update,
    deleteEntity
};

function getByAccount(accountId) {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refDataFormats/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refDataFormats/${id}`).then(handleResponse);
}

function add(refDataFormat) {
    return axios.post('/refDataFormats', refDataFormat).then(handleResponse);
}

function update(refDataFormat) {
    return axios.put(`/refDataFormats/${refDataFormat.refDataFormatId}`, refDataFormat).then(handleResponse);
}

function deleteEntity(refDataFormat) {
    return axios.delete(`/refDataFormats/${refDataFormat.refDataFormatId}`).then(handleResponse);
}
